<template>
    <div class="position-relative">
        <div
            v-click-outside="hideSearchBox"
            class="search-box"
            :class="{
                'search-box--open': showSearch,
                'search-box--has-suggestions':
                    suggestionResults.length && searchInput != ''
            }"
        >
            <input
                ref="searchInput"
                v-model="searchInput"
                class="search-box__input"
                type="text"
                @keydown.esc="hideSearchBox"
                @keydown.enter="executeSearch"
            />

            <button class="search-box__button" @click.prevent="toggleSearch">
                <i
                    v-if="!isSearching"
                    :class="[isSearching ? 'spinner' : 'fa fa-search']"
                ></i>
                <i v-else class="spinner"></i>
            </button>
        </div>
        <div
            v-if="
                searchInput !== '' &&
                    typeof suggestionResults !== 'undefined' &&
                    suggestionResults.length > 0
            "
            class="search-box-suggestions d-block mb-2"
        >
            <li v-for="(item, key) in suggestionResults" :key="key">
                <a :href="item.url">
                    {{ item.title }}
                </a>
            </li>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import ClickOutside from 'vue-click-outside';

export default {
    name: 'Searchbox',
    directives: {
        ClickOutside
    },
    data: function() {
        return {
            showSearch: false,
            searchInput: '',
            isSearching: false,
            suggestionResults: [],
            suggestionUrl: '/api/searchapi/homesearchSuggestions?q='
        };
    },
    watch: {
        searchInput: function() {
            if (this.searchInput != '') {
                Axios.get(this.suggestionUrl + this.searchInput)
                    .then(response => {
                        this.suggestionResults =
                            response.data.content.pagedResults;
                        return true;
                    })
                    .catch(error => {
                        this.suggestionResults.push(error.response);
                    });
            }
        }
    },
    methods: {
        toggleSearch() {
            if (this.searchInput !== '') {
                this.executeSearch();
            } else if (!this.showSearch) {
                this.$nextTick(() => this.$refs.searchInput.focus());
                this.showSearch = true;
            } else {
                this.hideSearchBox();
            }
        },
        hideSearchBox() {
            if (!this.isSearching) {
                this.showSearch = false;
                this.searchInput = '';
                this.suggestionResults = [];
            }
        },
        executeSearch() {
            this.isSearching = true;
            this.hideSearchBox();
            window.location =
                this.$root.settings.searchUrl + '?q=' + this.searchInput;
        }
    }
};
</script>

<style lang="scss" scoped>
.search-box {
    position: relative;
    width: 50px;
    height: 37px;
    overflow: hidden;
    border-radius: 23.5px;
    pointer-events: all;
    outline: none;
    transition: width 0.5s $easeOutQuad;

    @include media-breakpoint-up(md) {
        width: 67px;
        height: 47px;
    }

    &--open {
        width: 280px;

        @include media-breakpoint-up(md) {
            width: 350px;
        }
    }

    &--has-suggestions {
        z-index: 99;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

        .search-box__input {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }
    }
}

.search-box--has-suggestions + .search-box-suggestions {
    position: absolute;
    width: 100%;
    left: 0;
    top: 37px;
    pointer-events: all;
    background-color: $color-gray;
    padding: 20px 10px 10px 20px;
    border-bottom-left-radius: 23.5px;
    border-bottom-right-radius: 23.5px;
}

.search-box__input {
    position: absolute;
    width: 100%;
    height: 100%;
    padding-left: 23.5px;
    padding-right: 50px;
    border: solid 2px $color-blue;
    border-radius: 23.5px;
    outline: none;
    font-weight: $font-weight-light;
    background-color: white;
}

.search-box__button {
    position: absolute;
    width: 50px;
    height: 100%;
    top: 0;
    right: 0;
    padding: 0 10px;
    background-color: $color-blue;
    border: none;
    transition: all 0.25s linear;
    cursor: pointer;

    @include media-breakpoint-up(md) {
        width: 67px;
    }

    .fa {
        color: $color-white;
        background-color: $color-blue;
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        font-size: 20px;

        @include media-breakpoint-up(md) {
            font-size: 25px;
        }
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.spinner {
    animation: spin 1s ease-in-out infinite;
    display: inline-block;
    width: 25px;
    height: 25px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #fff;
    margin: 0 auto;
    vertical-align: middle;
}

.search-box-suggestions {
    padding: 10px 3px;
    position: relative;
    overflow: hidden;
    max-width: 100%;
    background-color: $color-white;

    li {
        margin-bottom: 4px;
        font-size: 0.925rem;
        list-style-type: none;
    }
}
</style>
